import {Color} from '@benchling/nucleus-ui';
import {createStyles, Group} from '@mantine/core';
import React from 'react';

import Chip, {ChipSize} from 'ui-library/chips/Chip';

const useStyles = createStyles({
  variesChip: {
    '&.chip, &.chip:hover, &.chip:focus, &.chip:focus-visible, &.chip:active': {
      marginRight: 0,
      padding: '2px 4px',
      backgroundColor: Color.GREEN_200,
      borderColor: Color.GREEN_200,
      color: Color.GREEN_600,
    },
  },
});

interface VaryingParameterNameProps {
  name: string;
}

export default function VaryingParameterName({name}: VaryingParameterNameProps): JSX.Element {
  const {classes} = useStyles();

  return (
    <Group spacing="xs">
      <span>{name}</span>
      <Chip size={ChipSize.MINI} text="Varies" isReadonly={true} className={classes.variesChip} />
    </Group>
  );
}
